import { ICreateEngineFiscalRulesState } from "@/@types/engine-fiscal-rules";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiscalRulesListState } from "./type";

const initialState: FiscalRulesListState = {
  list: [],
};

export const fiscalRulesListSlice = createSlice({
  name: "fiscalRulesList",
  initialState,
  reducers: {
    addItem: (state, action) => {
      state.list = [...state.list, action.payload];
    },
    removeItem: (
      state,
      action: PayloadAction<ICreateEngineFiscalRulesState>
    ) => {
      state.list = state.list.filter(
        (item) =>
          !(
            item.state === action.payload.state &&
            new Date(item.initial_term).getTime() ===
              new Date(action.payload.initial_term).getTime() &&
            item.tip === action.payload.tip &&
            item.alq === action.payload.alq &&
            item.cst === action.payload.cst
          )
      );
    },
    clearList: (state) => {
      state.list = [];
    },
  },
});

export const { addItem, removeItem, clearList } = fiscalRulesListSlice.actions;
export default fiscalRulesListSlice.reducer;
